module.exports = __webpack_public_path__ + "static/media/gifSeven.ad7c4c1e.gif";